<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor } from '$lib/helper';
    import { personalizeHtml } from '$lib/personalizeHtml';

    import AccordionView from './Accordion.View.svelte';

    import type { AccordionContent } from '$lib/types/Components/Accordion/AccordionContent';
    import type { AccordionItemContent } from '$lib/types/Components/Accordion/AccordionItemContent';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: AccordionContent;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let campaignId = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let theme: Theme;
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;

    const items = childComponents.map((item) => {
        const title = item.components[0];
        const body = item.components[1];
        const itemContent = item.content as AccordionItemContent;

        return {
            id: item._id,
            bgColor: itemContent.box?.backgroundColor,
            title: {
                wysiwygHtml: personalizeHtml(title.content.wysiwygHtml, {
                    trackingProperties,
                    campaignId,
                    language,
                }),
                color: getColor(title.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
            body: {
                wysiwygHtml: personalizeHtml(body.content.wysiwygHtml, {
                    trackingProperties,
                    campaignId,
                    language,
                }),
                color: getColor(body.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
        };
    });
</script>

<AccordionView
    {id}
    {items}
    {theme}
    {transitionDelay}
    {transitionEffect}
    box={content.box}
    {layout}
/>
